module.exports = __webpack_public_path__ + "assets/img/edit.24cd3f72.svg";